import { render, staticRenderFns } from "./CenterItemSelector.vue?vue&type=template&id=9f1333d4&"
import script from "./CenterItemSelector.vue?vue&type=script&lang=js&"
export * from "./CenterItemSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports